import React, { useState } from 'react';
import { Offcanvas, Button } from 'react-bootstrap';
import ItemDetail from '../ItemDetail/ItemDetail';
import "../Item/item.css"; // Asegúrate de importar los estilos
import { useCartContext } from '../Context/CartContext';

const Item = ({ item }) => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const { currentPrice } = useCartContext();

  const handleShow = () => setShowOffcanvas(true);
  const handleClose = () => setShowOffcanvas(false);

  return (
    <>
      <div className="card" onClick={handleShow} style={{ cursor: 'pointer', position: 'relative' }}>
        {item.promocion === 'si' && <div className="promo-badge">En Promo!</div>}
        <img
  className="card-img-top"
  src={
    (() => {
      try {
        const arr = Array.isArray(item.image) ? item.image : JSON.parse(item.image);
        return arr[0];
      } catch {
        return item.image;
      }
    })()
  }
  alt="Productos de la web"
  style={{ height: '250px', width: '250px', margin: '0 auto' }}
/>

        <div className="card-body">
          <h5 className="card-title">- Producto: {item.name}</h5>
          <p><b>Clickea para Ampliar info!</b></p>
        </div>
      </div>

      {/* Offcanvas con clase personalizada para ancho dinámico */}
      <Offcanvas show={showOffcanvas} onHide={handleClose} placement="start" className="offcanvas-custom">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Detalle del producto: {item.name} </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ItemDetail item={item} />
        </Offcanvas.Body>
        <div className="p-3 text-center">
          <h3>Precio del producto: ${item.precio}</h3>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </div>
      </Offcanvas>
    </>
  );
};

export default Item;
